export default "__VITE_ASSET__BNU55dNF__"